export default "__VITE_ASSET__Dq24net$__"